
import { useStaticRendering } from 'mobx-react';
import isServer from '@common/utils/is-server';
import store from './store';
import CommonAction from './common/action';
import AppAction from './app/action';
import SiteAction from './site/action';
import userAction from './user/action';
import threadAction from './thread/action';
import topicAction from './topic/action';
import activityAction from './activity/action';
import setPost from './setPost/action';
import HouseAction from './house/action';
import PhotographyAction from './photography/action';
import ProductAction from './product/action';
import GoodsAction from './goods/action';
import LotteryAction from './lottery/action';

// 只允许在 React 组件或自定义 Hook 内部调用 useStaticRendering
export function setupStaticRendering() {
    useStaticRendering(isServer());
}

export default function initializeStore(initProps = {}) {
    const { site = {}, user = {} } = initProps;

    if (isServer()) {
        // 服务端渲染，每次请求创建新的 store
        return {
            common: CommonAction,
            app: new AppAction(),
            site: SiteAction,
            user: userAction,
            thread: threadAction,
            topic: topicAction,
            activity: activityAction,
            setPost: new setPost(),
            house: HouseAction,
            photography: PhotographyAction,
            product: ProductAction,
            goods: GoodsAction,
            lottery: LotteryAction,
        };
    }

    // 客户端，使用单例 store
    if (store.getStore() === null) {
        store.setStore({
            common: CommonAction,
            app: new AppAction(),
            site: SiteAction,
            user: userAction,
            thread: threadAction,
            topic: topicAction,
            activity: activityAction,
            setPost: new setPost(),
            house: HouseAction,
            photography: PhotographyAction,
            product: ProductAction,
            goods: GoodsAction,
            lottery: LotteryAction,
        });
    }

    return store.getStore();
}
